/** EN uses Swedish values until translated. */
export const investorsTranslationsEn = {
    yearlyOverview: {
        title: 'Summary',
        guarantor: 'Guarantor',
        subscription: 'Sub commitment',
        participant: 'Participant',
        total: 'Total',
    },
    history: {
        title: 'History',
        noResults: 'No previous share issues found',
        cancelledSuffix: '(cancelled)',
        viewIssueDetails: 'Show details about the issue',
        viewWarrantDetails: 'Show details about the warrant',
        amountDisclaimer: 'Complete information regarding the amount per participant has not been communicated by the company.',
        columns: {
            date: 'Date',
            instrument: 'Share/warrant',
            sector: 'Sector',
            financialAdvisor: 'Fin. advisor',
            commitment: 'Commitment',
            amount: 'Amount',
        },
    },
    commitmentTypes: {
        seller: 'Seller',
        subscriptionWithoutRights: 'SC without rights',
        subscription: 'Sub commitment',
        lender: 'Lender',
        participant: 'Participant',
        putOption: 'Sub-guarantor',
        guarantee: 'Guarantor',
    },
}
